/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApfmMedicationResponse
 */
export interface ApfmMedicationResponse {
    /**
     * 
     * @type {string}
     * @memberof ApfmMedicationResponse
     */
    profile_medication?: string;
    /**
     * 
     * @type {string}
     * @memberof ApfmMedicationResponse
     */
    profile_taking_medication?: string;
}

/**
 * Check if a given object implements the ApfmMedicationResponse interface.
 */
export function instanceOfApfmMedicationResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApfmMedicationResponseFromJSON(json: any): ApfmMedicationResponse {
    return ApfmMedicationResponseFromJSONTyped(json, false);
}

export function ApfmMedicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApfmMedicationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile_medication': !exists(json, 'profile_medication') ? undefined : json['profile_medication'],
        'profile_taking_medication': !exists(json, 'profile_taking_medication') ? undefined : json['profile_taking_medication'],
    };
}

export function ApfmMedicationResponseToJSON(value?: ApfmMedicationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile_medication': value.profile_medication,
        'profile_taking_medication': value.profile_taking_medication,
    };
}

